export function getMaxDate(duration: number) {
    const daysToAdd = duration - 1;
    const maxDate = addDays(daysToAdd);

    return maxDate;
}

function addDays(daysToAdd: number) {
    const time = new Date().getTime();
    const timeToAdd = daysToAdd * 24 * 60 * 60 * 1000;
    const finalDate = new Date(time + timeToAdd);

    return finalDate.toISOString().slice(0, 10);
}

// This function is preferable over date-fns as it
// will not try to mutate the new Date() which we mock
// in our tests
export function addMonths(monthsToAdd: number) {
    const date = new Date();
    const desiredDay = date.getDate();
    const desiredMonth = date.getMonth() + monthsToAdd;
    const desiredYear = date.getFullYear();
    const desiredHours = [0, 0, 0, 0];

    const daysInMonth = new Date(
        desiredYear,
        desiredMonth + 1,
        0,
        ...desiredHours
    ).getDate();

    const targetDate = new Date(
        desiredYear,
        desiredMonth,
        Math.min(daysInMonth, desiredDay)
    );

    // This corrects for the new Date() constructor using
    // a different timezone in tests when passed arguments
    const offsetCorrection = -1 * targetDate.getTimezoneOffset();
    const correctedDate = new Date(
        targetDate.getTime() + offsetCorrection * 60 * 1000
    );

    return correctedDate;
}

export function differenceBetweenDates(date: Date) {
    const today = new Date();
    const endingDate = new Date(date).toISOString().substr(0, 10);
    const endDate = new Date(endingDate);

    const startYear = today.getFullYear();
    const february =
        (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
            ? 29
            : 28;
    const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let yearDiff = endDate.getFullYear() - startYear;
    let monthDiff = endDate.getMonth() - today.getMonth();
    let dayDiff = endDate.getDate() - today.getDate();

    if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
    }

    if (dayDiff < 0) {
        if (monthDiff > 0) {
            monthDiff--;
        } else {
            yearDiff--;
            monthDiff = 11;
        }
        dayDiff += daysInMonth[today.getMonth()];
    }

    return [yearDiff, monthDiff, dayDiff];
}
